import React from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { SharedButton } from '@/components/shared/Button';

export const Presentation: React.FC = () => {
  const { t } = useTranslation();
  const title = t('ui.oidc.callback.error.title');
  const content = t('ui.oidc.callback.error.content');
  const btnHome = t('ui.oidc.callback.error.btnHome');

  return (
    <Wrapper>
      <Title>{title}</Title>
      <Content>
        <span>{content}</span>
      </Content>
      <HomeButton>
        <Link to="/" className="home-button">
          <SharedButton buttonType="wide" fontSize="small">
            {btnHome}
          </SharedButton>
        </Link>
      </HomeButton>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  text-align: center;
  padding: 14px;
  margin: 14px 0 !important;
`;

const Title = styled.h1`
  font-weight: 400;
  font-size: 2.3rem;
`;

const Content = styled.div`
  color: #db3333;
  padding-top: 30px;
  font-size: 1.3rem;
`;

const HomeButton = styled.div`
  margin-top: 130px;
`;
